<!--底图组件-->
<template>
  <div>
    <el-dialog title="地图绘制工具" :visible="true" top="6vh" width="60%" @close="closeDialog">
      <div id="mapContainer">
      </div>
      <div slot="footer" class="dialog-footer" style="margin:auto">
        <el-button @click="closeDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="drawOk" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style>

</style>
<script>
import * as Cesium from 'cesium';
import CesiumNavigation from 'cesium-navigation-es6';
import CONSTANTS from "./constants";
import DrawTool from "@/views/map/utils/DrawTool";
import * as MapService from "@/api/map";

export default {
  name: 'DrawMap',
  data(){
    return {
      geoJson:null
    }
  },
  props:{
    initCoords: {
      type: Array,
      default: () => []
    },
    drawType:String,
    closeDrawer:Function
  },
  mounted(){
    let self=this;
    this.$nextTick(() => {
      self.initViewer();
    })
  },
  methods:{
    initViewer(){
      let self=this;
      //初始化viewer
      let viewer = new Cesium.Viewer('mapContainer',{
          animation: false, //是否创建动画小器件，左下角仪表
          baseLayerPicker: false, //是否显示图层选择器
          fullscreenButton: false, //是否显示全屏按钮
          geocoder: false, //是否显示geocoder小器件，右上角查询按钮
          homeButton: false, //是否显示Home按钮
          infoBox: false, //是否显示信息框
          selectionIndicator: false, //是否显示选取指示器组件
          timeline: false, //是否显示时间轴
          navigationHelpButton: false, //是否显示右上角的帮助按钮
          scene3DOnly: true, //如果设置为true，则所有几何图形以3D模式绘制以节约GPU资源
          clock: new Cesium.Clock(), //用于控制当前时间的时钟对象
          fullscreenElement: document.body, //全屏时渲染的HTML元素,
          useDefaultRenderLoop: true, //如果需要控制渲染循环，则设为true
          showRenderLoopErrors: false, //如果设为true，将在一个HTML面板中显示错误信息
          automaticallyTrackDataSourceClocks: true, //自动追踪最近添加的数据源的时钟设置
          sceneMode: Cesium.SceneMode.SCENE3D, //初始场景模式
          orderIndependentTranslucency: false,
          imageryProvider:new Cesium.WebMapTileServiceImageryProvider(CONSTANTS.TILE.tiandituImg),
          contextOptions: {
            webgl: {
              alpha: true,
            }
          },
      });
      viewer.scene.skyBox.show = false;
      viewer.scene.backgroundColor = new Cesium.Color(0.0, 0.0, 0.0, 0.0);
      viewer.imageryLayers.addImageryProvider(new Cesium.WebMapTileServiceImageryProvider(CONSTANTS.TILE.tiandituCia));
      let options = {};
      // 用于在使用重置导航重置地图视图时设置默认视图控制。接受的值是Cesium.Cartographic 和Cesium.Rectangle.
      options.defaultResetView = Cesium.Rectangle.fromDegrees(80, 22, 130, 50);
      // 罗盘,用于启用或禁用罗盘。true是启用罗盘，false是禁用罗盘。默认值为true。如果将选项设置为false，则罗盘将不会添加到地图中。
      options.enableCompass= true;
      // 缩放控件,用于启用或禁用缩放控件。true是启用，false是禁用。默认值为true。如果将选项设置为false，则缩放控件 将不会添加到地图中。
      options.enableZoomControls= true;
      // 距离图例,用于启用或禁用距离图例。true是启用，false是禁用。默认值为true。如果将选项设置为false，距离图例将不会添加到地图中。
      options.enableDistanceLegend= true;
      // 指南针外环,用于启用或禁用指南针外环。true是启用，false是禁用。默认值为true。如果将选项设置为false，则该环将可见但无效。
      options.enableCompassOuterRing= true;
      new CesiumNavigation(viewer, options);//主要方法

      self.viewer=viewer;
      document.getElementsByClassName('cesium-viewer-bottom')[0].style.display ='none';

      MapService.getModelList().then(res => {
        if (res.data.status_code === 100) {
          res.data.data.map((item)=>{
            let coords=item.coor.split(",");
            self.loadModel({
              id:item.id,
              url:item.url,
              lng:Number(coords[0]),
              lat:Number(coords[1]),
              alt:Number(item.heading||0),
              show:true
            });
          })
        }
      })

      //绘制工具,点=Point，线=Polyline，面=Polygon
      this.drawTool=new DrawTool(viewer);
      if(this.drawType){
        this.drawTool.activate(this.drawType,(data)=>{
          console.log(data);
          this.geoJson=data;
        });
      }
    },

    /**
     * 加载模型
     * @param modelData
     */
    loadModel(modelData){
      let self=this;
      self.viewer.scene.primitives.add( new Cesium.Cesium3DTileset({
        url: modelData.url
      })).readyPromise.then(_tileset => {
        _tileset.id = modelData.id;
        _tileset.show = modelData.show;
        _tileset.type='tileset';
        let cartographic = Cesium.Cartographic.fromCartesian(
            _tileset.boundingSphere.center
        );
        let longitude=modelData.lng||Cesium.Math.toDegrees(cartographic.longitude);
        let latitude=modelData.lat||Cesium.Math.toDegrees(cartographic.latitude);
        let height=modelData.alt||cartographic.height;

        //旋转角度设置
        let mx = Cesium.Matrix3.fromRotationX(Cesium.Math.toRadians(modelData.rotate?.rx||0));
        let my = Cesium.Matrix3.fromRotationY(Cesium.Math.toRadians(modelData.rotate?.ry||0));
        let mz = Cesium.Matrix3.fromRotationZ(Cesium.Math.toRadians(modelData.rotate?.rz||0));
        let rotationX = Cesium.Matrix4.fromRotationTranslation(mx);
        let rotationY = Cesium.Matrix4.fromRotationTranslation(my);
        let rotationZ = Cesium.Matrix4.fromRotationTranslation(mz);
        //平移 修改经纬度
        let position = Cesium.Cartesian3.fromDegrees(longitude,latitude,height);
        let transform = Cesium.Transforms.eastNorthUpToFixedFrame(position);
        //旋转、平移矩阵相乘
        Cesium.Matrix4.multiply(transform, rotationX, transform);
        Cesium.Matrix4.multiply(transform, rotationY, transform);
        Cesium.Matrix4.multiply(transform, rotationZ, transform);
        //缩放 修改缩放比例
        let scale = Cesium.Matrix4.fromUniformScale(1);
        Cesium.Matrix4.multiply(transform, scale, transform);
        //赋值给tileset
        _tileset._root.transform = transform;
        //window.viewer.zoomTo(_tileset);//飞行模型位置

        //初始化相机
        _tileset.show&&self.viewer.camera.setView({
          destination:Cesium.Cartesian3.fromDegrees(modelData.lng, modelData.lat,1000),
          orientation:{
            heading : Cesium.Math.toRadians(Number(0)),// 指向
            pitch : Cesium.Math.toRadians(Number(-90)),// 视角
            roll : Number(0)
          }
        })
      });
    },

    drawOk(){
      this.closeDrawer&&this.closeDrawer(this.geoJson);
    },
    clearAll(){
      this.drawTool.clearAll();
    },
    // 关闭弹出框的事件
    closeDialog() {
      this.closeDrawer&&this.closeDrawer();
    },
  },
  beforeDestroy() {
    this.viewer&&this.viewer.destroy();
  }
}
</script>
<style scoped>
@import "map.css";
/deep/ .compass{
  right: 0px;
  left: auto;
}
/deep/ .navigation-controls{
  right: 30px;
  left: auto;
}
</style>
